import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterLink } from '@angular/router'
import { DataMap } from '@grapecity/wijmo.grid'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, EquipmentTireConfig, Grid, ListItem, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { EquipmentTireConfigModalComponent } from '../tire-management/equipment-tire-config-modal.component'
import { PartsFluidsEquipmentContext } from './parts-fluids-equipment-context'

@Component({
    selector: 'app-equipment-tire-config-list',
    templateUrl: './equipment-tire-config-list.component.html',
    standalone: true,
    imports: [
        FormsModule,
        RouterLink,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        WjGridFilterModule,
        AutoSizeDirective,
    ],
})
export class EquipmentTireConfigListComponent extends BaseComponent implements OnChanges, PartsFluidsEquipmentContext {
    @Input() canEdit = false
    @Input() equipmentOptions: ListItem<string>[] = []
    @Input() equipmentDataMap!: DataMap
    @Input() allItems: EquipmentTireConfig[] = []
    @Input() parent!: PartsFluidsEquipmentContext

    grid: Grid<EquipmentTireConfig>

    constructor() {
        super()
        this.grid = new Grid<EquipmentTireConfig>(this.services, 'equipment', this)
            .setupModalEditing(
                this.services.data.equipmentTireConfigs,
                'Equipment Tire Config',
                EquipmentTireConfigModalComponent,
                () => {
                    const c = new EquipmentTireConfig()
                    c.id = crypto.randomUUID()
                    c.side = 'Left'
                    c.axleNumber = 1
                    return c
                },
                this,
                ModalSize.large,
            )
            .filterBy(item => [item.equipment, item.tireSize, item.side, item.positionLabel])
    }

    ngOnChanges() {
        this.grid.items = this.allItems
    }

    refresh() {
        this.parent.refresh()
    }

    equipmentDisplay(code: string | null | undefined): string {
        return this.parent.equipmentDisplay(code)
    }
}
